import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function getTenantSlug() {
  // Path-based tenant identification: first segment of URL.
  // Production alternative (subdomain): const host = window.location.hostname.split('.')[0];
  const segments = window.location.pathname.split('/').filter(Boolean);
  if (!segments.length) return null;
  if (segments[0] === 'superadmin') return null;
  return segments[0];
}

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
  const path = config.url || '';
  const isSuperAdmin = path.startsWith('/superadmin/') || path.startsWith('superadmin/')
    || path.startsWith('/whatsapp/admin') || path === '/whatsapp/qrcode';

  if (isSuperAdmin) {
    const t = localStorage.getItem('fin_sa_token');
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } else {
    const slug = getTenantSlug();
    if (slug) config.headers['X-Tenant-Slug'] = slug;
    const t = localStorage.getItem('fin_token');
    if (t) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith('/superadmin')) {
        localStorage.removeItem('fin_sa_token');
        if (!path.endsWith('/login')) window.location.href = '/superadmin/login';
      } else {
        const slug = getTenantSlug();
        localStorage.removeItem('fin_token');
        if (slug && !path.endsWith('/login')) window.location.href = `/${slug}/login`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
